import { ScheduleEventDeviceConfig } from '@thingslog/repositories';
import { EventConfigFactory } from './EventConfigFactory';

export class TasmotaPowerFactory implements EventConfigFactory {
  public create(deviceNumbers: string[]): ScheduleEventDeviceConfig {
    return {
      '@type': 'TASMOTA_POWER',
      deviceCommand: 'TASMOTA_POWER',
      deviceNumbers,
      requiredState: 'ON',
      sensorIndex: 0,
    };
  }
}
